/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import Slider from 'react-slick'
import { useNavigate, useLocation } from 'react-router-dom'
import { Modal, ModalBody } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import { noriCombinations, ticketGeneration } from '../../query/nori/nori.query'
import { getCurrentPoolData } from '../../query/home/home.query'
import Header from '../../components/Header'
import Footer from '../../components/footer'
import Sidebar from '../../components/Sidebar'
import Loading from '../../components/Loader'
import FirstComponent from './Step-Components/FirstComponent'
import SecondComponent from './Step-Components/SecondComponent'
import ThirdComponent from './Step-Components/ThirdComponent'
import FourthComponent from './Step-Components/FourthComponent'
import FifthComponent from './Step-Components/FifthComponent'
import SixthComponent from './Step-Components/SixthComponent'
import SeventhComponent from './Step-Components/SeventhComponent'
import EightComponent from './Step-Components/EightComponent'
import NinthComponent from './Step-Components/NinthComponent'
import ScrollTop from '../../config/scroll'
import TicketModal from '../Home/TicketModal'
import BuyModal from '../../components/buyModal'

import '../../assets/sass/views/Nori.scss'
import '../../assets/sass/views/Home.scss'
import redballimg from '../../assets/images/red-ball-img.png'
import blueballimg from '../../assets/images/blue-ball-img.png'
import loaderimg from '../../assets/images/loading.gif'

import closeicon from '../../assets/images/close-icon.svg'
import previcon from '../../assets/images/arrow-left.png'
import nexticon from '../../assets/images/arrow-right.png'

const Nori = () => {
  const { t } = useTranslation('global')
  const winningnumbersslider = () => {
    return (
      {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        swipeToSlide: true,
        focusOnSelect: true,
        centerPadding: '10px',
        vertical: true,
        infinite: true,
        swipe: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              vertical: false

            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              vertical: false

            }
          }
        ]
      }
    )
  }
  const [isVertical, setIsVertical] = useState(true)
  const [slides, setSlides] = useState(4)
  useEffect(() => {
    const handleResize = () => {
      // Si la largeur de l'écran est inférieure à 768px, on active le défilement vertical
      if (window.innerWidth < 991) {
        setIsVertical(false)
      } else {
        setIsVertical(true)
      }
      if (window.innerWidth < 768) {
        setSlides(2)
      } else {
        setSlides(4)
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState({ status: true })
  const [homeData, setHomeData] = useState({})
  const [isFetch, setIsFetch] = useState(false)
  const [showBuy, setShowBuy] = useState(false)
  const [partNoriComp, setPartNoriComp] = useState({ noOfComb: 1, noriComp: false, generationComp: false, valError: 0, test: 0 })
  const [tickets, setTickets] = useState(state?.ticket
    ? state.ticket
    : state?.tickets?.length
      ? state.tickets
      : [
          { id: 1, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 2, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 3, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 4, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 5, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 6, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 7, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 8, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 9, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 10, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 11, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 12, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 13, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false },
          { id: 14, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false }
        ])
  const [prevActiveStep, setPrevActiveStep] = useState(true)
  const [modal, setModal] = useState(false)
  const togglemodal = () => {
    return setModal(!modal)
  }
  const [limitModal, setLimitModal] = useState(false)
  const limitToggleModal = () => {
    return setLimitModal(!limitModal)
  }
  const goPrev = () => {
    winningnumbersslider.current.slickPrev()
  }
  const goNext = () => {
    winningnumbersslider.current.slickNext()
  }
  useQuery(['current-pool', isFetch], getCurrentPoolData, {
    select: (data) => {
      return data?.data
    },
    onSuccess: async (data) => {
      if (!state) setHomeData(data)
      setIsFetch(false)
    },
    onError: () => {
      navigate('/error', { state: { errorMsg: t('views.nori.nori.error') } })
    }
  })

  useEffect(() => {
    setTimeout(() => {
      setLoading({ status: false })
    }, 500)
    if (state === null) { setIsFetch(true) }
  }, [])

  useEffect(() => {

  }, [tickets])

  const [containsNull, setContainsNull] = useState(0)
  const { refetch, isLoading } = useQuery('ticket-generate', () => ticketGeneration(steps, npc.ncb, partNoriComp.noOfComb), {
    enabled: false,
    select: (data) => {
      return data?.data
    },
    onSuccess: (data) => {
      const finalTicketState = [...tickets]
      const finalObj = partNoriComp
      const indexFind = finalTicketState?.findIndex((t) => {
        return t.selectedNo.length === 0
      })
      setContainsNull(0)
      if (indexFind > -1) {
        for (let i = indexFind; i < indexFind + data.length; i++) {
          for (let j = 0; j < data.length; j++) {
            if (data[j - containsNull].n.includes(0)) setContainsNull(containsNull + 1)
            else finalTicketState[indexFind + j - containsNull] = { id: (j - containsNull) + indexFind + 1, selectedNo: data[j].n, totalSelectedNo: 6, autoGenerated: true, confirmClick: true, noriCompetition: partNoriComp.noriComp }
          }
        }
      } else {
        for (let j = 0; j < data.length; j++) {
          if (data[j - containsNull].n.includes(0)) setContainsNull(containsNull + 1)
          else finalTicketState.push({ id: tickets.length + 1 + j - containsNull, selectedNo: data[j].n, totalSelectedNo: 6, autoGenerated: true, confirmClick: true, noriCompetition: partNoriComp.noriComp })
        }
      }
      if (!finalTicketState[finalTicketState?.length]?.selectedNo?.length) finalTicketState.push({ id: finalTicketState.length + 1, selectedNo: [], totalSelectedNo: 0, autoGenerated: false, confirmClick: false, noriCompetition: false })
      setTickets(finalTicketState)
      finalObj.generationComp = true
      finalObj.test = data.length - containsNull
      setPartNoriComp(finalObj)
    },
    onError: () => {
      navigate('/error', { state: { errorMsg: t('views.nori.nori.error') } })
    }
  })

  const firstComponent = () => {
    return (
      <FirstComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} noriType={1} />
    )
  }
  const secondComponent = () => {
    return (
      <SecondComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const thirdComponent = () => {
    return (
      <ThirdComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const fourthComponent = () => {
    return (
      <FourthComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const fifthComponent = () => {
    return (
      <FifthComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const sixthComponent = () => {
    return (
      <SixthComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const seventhComponent = () => {
    return (
      <SeventhComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const eightComponent = () => {
    return (
      <EightComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} noriType={1} />
    )
  }
  const ninthComponent = () => {
    return (
      <NinthComponent
        steps={steps}
        togglemodal={togglemodal}
        modal={modal}
        partNoriComp={partNoriComp}
        setPartNoriComp={setPartNoriComp}
        setPrevActiveStep={setPrevActiveStep}
        npc={npc}
        limitToggleModal={limitToggleModal}
        tickets={tickets}
        refetch={refetch}
        noriType={1} />
    )
  }

  const [steps, setSteps] = useState(state?.reuseNoriData
    ? [
        { id: 1, key: 'step1', label: t('views.nori.nori.step1'), tooltip: t('views.nori.nori.stepDetails1'), isVisited: false, isDone: false, isSelected: state.reuseNoriData?.noriParams?.ops?.op1 || true, component: firstComponent },
        { id: 5, key: 'step5', label: t('views.nori.nori.step5'), tooltip: t('views.nori.nori.stepDetails5'), isVisited: false, selFilterCriteria: [{ id: 1, key: t('views.nori.nori.step51'), min: state.reuseNoriData?.noriParams?.ftr?.nbMn || 0, max: state.reuseNoriData?.noriParams?.ftr?.nbMx, tooltip: t('views.nori.nori.stepDetails51') }, { id: 2, key: t('views.nori.nori.step52'), min: state.reuseNoriData?.noriParams?.ftr?.evMn || 0, max: state.reuseNoriData?.noriParams?.ftr?.evMx, tooltip: t('views.nori.nori.stepDetails52') }, { id: 3, key: t('views.nori.nori.step53'), min: state.reuseNoriData?.noriParams?.ftr?.odMn || 0, max: state.reuseNoriData?.noriParams?.ftr?.odMx, tooltip: t('views.nori.nori.stepDetails53') }, { id: 4, key: t('views.nori.nori.step54'), min: state.reuseNoriData?.noriParams?.ftr?.evnbMn || 0, max: state.reuseNoriData?.noriParams?.ftr?.evnbMx, tooltip: t('views.nori.nori.stepDetails54') }, { id: 5, key: t('views.nori.nori.step55'), min: state.reuseNoriData?.noriParams?.ftr?.odnbMn || 0, max: state.reuseNoriData?.noriParams?.ftr?.odnbMx, tooltip: t('views.nori.nori.stepDetails55') }, { id: 6, key: t('views.nori.nori.step56'), min: state.reuseNoriData?.noriParams?.ftr?.pnMn || 0, max: state.reuseNoriData?.noriParams?.ftr?.pnMx, tooltip: t('views.nori.nori.stepDetails56') }], isDone: false, isSelected: state.reuseNoriData?.noriParams?.ops?.op5 || false, component: fifthComponent },
        { id: 2, key: 'step2', label: t('views.nori.nori.step2'), tooltip: t('views.nori.nori.stepDetails2'), isVisited: false, selectedNum: state.reuseNoriData?.noriParams?.mns || [], isDone: false, isSelected: state.reuseNoriData?.noriParams?.ops?.op2 || false, component: secondComponent },
        { id: 6, key: 'step6', label: t('views.nori.nori.step6'), tooltip: t('views.nori.nori.stepDetails6'), isVisited: false, selAdvanceFilterCriteria: [{ id: 1, key: t('views.nori.nori.step61'), min: state.reuseNoriData?.noriParams?.adftr?.avMn, max: state.reuseNoriData?.noriParams?.adftr?.avMx, dmin: state.reuseNoriData?.noriParams?.adftr?.avMn, dmax: state.reuseNoriData?.noriParams?.adftr?.avMx, tooltip: t('views.nori.nori.stepDetails61') }, { id: 2, key: t('views.nori.nori.step62'), min: state.reuseNoriData?.noriParams?.adftr?.clMn, max: state.reuseNoriData?.noriParams?.adftr?.clMx, dmin: state.reuseNoriData?.noriParams?.adftr?.clMn, dmax: state.reuseNoriData?.noriParams?.adftr?.clMx, tooltip: t('views.nori.nori.stepDetails62') }, { id: 3, key: t('views.nori.nori.step63'), min: state.reuseNoriData?.noriParams?.adftr?.spnbMn, max: state.reuseNoriData?.noriParams?.adftr?.spnbMx, dmin: state.reuseNoriData?.noriParams?.adftr?.spnbMn, dmax: state.reuseNoriData?.noriParams?.adftr?.spnbMx, tooltip: t('views.nori.nori.stepDetails63') }, { id: 4, key: t('views.nori.nori.step64'), min: state.reuseNoriData?.noriParams?.adftr?.speqMn, max: state.reuseNoriData?.noriParams?.adftr?.speqMx, dmin: state.reuseNoriData?.noriParams?.adftr?.speqMn, dmax: state.reuseNoriData?.noriParams?.adftr?.speqMx, tooltip: t('views.nori.nori.stepDetails64') }, { id: 5, key: t('views.nori.nori.step65'), min: state.reuseNoriData?.noriParams?.adftr?.spnqMn, max: state.reuseNoriData?.noriParams?.adftr?.spnqMx, dmin: state.reuseNoriData?.noriParams?.adftr?.spnqMn, dmax: state.reuseNoriData?.noriParams?.adftr?.spnqMx, tooltip: t('views.nori.nori.stepDetails65') }, { id: 6, key: t('views.nori.nori.step66'), min: state.reuseNoriData?.noriParams?.adftr?.unMn, max: state.reuseNoriData?.noriParams?.adftr?.unMx, dmin: state.reuseNoriData?.noriParams?.adftr?.unMn, dmax: state.reuseNoriData?.noriParams?.adftr?.unMx, tooltip: t('views.nori.nori.stepDetails66') }, { id: 7, key: t('views.nori.nori.step67'), min: state.reuseNoriData?.noriParams?.adftr?.acMn, max: state.reuseNoriData?.noriParams?.adftr?.acMx, dmin: state.reuseNoriData?.noriParams?.adftr?.acMn, dmax: state.reuseNoriData?.noriParams?.adftr?.acMx, tooltip: t('views.nori.nori.stepDetails67') }], tolerance: state.reuseNoriData?.noriParams?.adftr?.tolMn, tolTooltip: t('views.nori.nori.stepDetails68'), isDone: false, isSelected: state.reuseNoriData?.noriParams?.ops?.op6 || false, component: sixthComponent },
        { id: 3, key: 'step3', label: t('views.nori.nori.step3'), tooltip: t('views.nori.nori.stepDetails3'), isVisited: false, selectedExcludeNum: state.reuseNoriData?.noriParams?.qns || [], isDone: false, isSelected: state.reuseNoriData?.noriParams?.ops?.op3 || false, component: thirdComponent },
        { id: 7, key: 'step7', label: t('views.nori.nori.step7'), tooltip: t('views.nori.nori.stepDetails7'), isVisited: false, selAppPartiNum: state.reuseNoriData?.noriParams?.p2nbs || [], quota: state.reuseNoriData?.noriParams?.p1ns || 6, isDone: false, isSelected: state.reuseNoriData?.noriParams?.ops?.op7 || false, component: seventhComponent },
        { id: 4, key: 'step4', label: t('views.nori.nori.step4'), tooltip: t('views.nori.nori.stepDetails4'), isVisited: false, selPriGrpNum: state.reuseNoriData?.noriParams?.pns || [], highPrio: 100 - Number(state.reuseNoriData?.noriParams?.pd || 51), lowPrio: Number(state.reuseNoriData?.noriParams?.pd || 49), isDone: false, isSelected: state.reuseNoriData?.noriParams.ops?.op4 || false, component: fourthComponent },
        { id: 8, key: 'step8', label: t('views.nori.nori.step8'), tooltip: t('views.nori.nori.stepDetails8'), isVisited: false, selBlockWiseNum: [{ id: 1, numbers: state?.reuseNoriData?.noriParams?.bcs?.[0]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }, { id: 2, numbers: state?.reuseNoriData?.noriParams?.bcs?.[1]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }, { id: 3, numbers: state?.reuseNoriData?.noriParams?.bcs?.[2]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }, { id: 4, numbers: state?.reuseNoriData?.noriParams?.bcs?.[3]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }, { id: 5, numbers: state?.reuseNoriData?.noriParams?.bcs?.[4]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }, { id: 6, numbers: state?.reuseNoriData?.noriParams?.bcs?.[5]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }, { id: 7, numbers: state?.reuseNoriData?.noriParams?.bcs?.[6]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }, { id: 8, numbers: state?.reuseNoriData?.noriParams?.bcs?.[7]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }, { id: 9, numbers: state?.reuseNoriData?.noriParams?.bcs?.[8]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }, { id: 10, numbers: state?.reuseNoriData?.noriParams?.bcs?.[9]?.n ?? [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: state?.reuseNoriData?.noriParams?.pns }], numOfBlocks: state?.reuseNoriData?.noriParams?.bcs?.length ?? 0, isDone: false, isSelected: state?.reuseNoriData?.noriParams?.ops?.op8 || false, component: eightComponent },
        { id: 9, key: 'step9', label: t('views.nori.nori.step9'), isVisited: false, isDone: false, isSelected: false, component: ninthComponent }]
    : [
        { id: 1, key: 'step1', label: t('views.nori.nori.step1'), tooltip: t('views.nori.nori.stepDetails1'), isVisited: false, isDone: false, isSelected: true, component: firstComponent },
        { id: 5, key: 'step5', label: t('views.nori.nori.step5'), tooltip: t('views.nori.nori.stepDetails5'), isVisited: false, selFilterCriteria: [{ id: 1, key: t('views.nori.nori.step51'), min: 0, max: 6, tooltip: t('views.nori.nori.stepDetails51') }, { id: 2, key: t('views.nori.nori.step52'), min: 0, max: 6, tooltip: t('views.nori.nori.stepDetails52') }, { id: 3, key: t('views.nori.nori.step53'), min: 0, max: 6, tooltip: t('views.nori.nori.stepDetails53') }, { id: 4, key: t('views.nori.nori.step54'), min: 0, max: 6, tooltip: t('views.nori.nori.stepDetails54') }, { id: 5, key: t('views.nori.nori.step55'), min: 0, max: 6, tooltip: t('views.nori.nori.stepDetails55') }, { id: 6, key: t('views.nori.nori.step56'), min: 0, max: 6, tooltip: t('views.nori.nori.stepDetails56') }], isDone: false, isSelected: false, component: fifthComponent },
        { id: 2, key: 'step2', label: t('views.nori.nori.step2'), tooltip: t('views.nori.nori.stepDetails2'), isVisited: false, selectedNum: [], isDone: false, isSelected: false, component: secondComponent },
        { id: 6, key: 'step6', label: t('views.nori.nori.step6'), tooltip: t('views.nori.nori.stepDetails6'), isVisited: false, selAdvanceFilterCriteria: [{ id: 1, key: t('views.nori.nori.step61'), min: 3, max: 40, dmin: 3, dmax: 40, tooltip: t('views.nori.nori.stepDetails61') }, { id: 2, key: t('views.nori.nori.step62'), min: 5, max: 41, dmin: 5, dmax: 41, tooltip: t('views.nori.nori.stepDetails62') }, { id: 3, key: t('views.nori.nori.step63'), min: 1, max: 37, dmin: 1, dmax: 37, tooltip: t('views.nori.nori.stepDetails63') }, { id: 4, key: t('views.nori.nori.step64'), min: 1, max: 5, dmin: 1, dmax: 5, tooltip: t('views.nori.nori.stepDetails64') }, { id: 5, key: t('views.nori.nori.step65'), min: 1, max: 5, dmin: 1, dmax: 5, tooltip: t('views.nori.nori.stepDetails65') }, { id: 6, key: t('views.nori.nori.step66'), min: 1, max: 6, dmin: 1, dmax: 6, tooltip: t('views.nori.nori.stepDetails66') }, { id: 7, key: t('views.nori.nori.step67'), min: 0, max: 10, dmin: 0, dmax: 10, tooltip: t('views.nori.nori.stepDetails67') }], tolerance: 0, tolTooltip: t('views.nori.nori.stepDetails68'), isDone: false, isSelected: false, component: sixthComponent },
        { id: 3, key: 'step3', label: t('views.nori.nori.step3'), tooltip: t('views.nori.nori.stepDetails3'), isVisited: false, selectedExcludeNum: [], isDone: false, isSelected: false, component: thirdComponent },
        { id: 7, key: 'step7', label: t('views.nori.nori.step7'), tooltip: t('views.nori.nori.stepDetails7'), isVisited: false, selAppPartiNum: [], quota: 6, isDone: false, isSelected: false, component: seventhComponent },
        { id: 4, key: 'step4', label: t('views.nori.nori.step4'), tooltip: t('views.nori.nori.stepDetails4'), isVisited: false, selPriGrpNum: [], highPrio: 51, lowPrio: 49, isDone: false, isSelected: false, component: fourthComponent },
        { id: 8, key: 'step8', label: t('views.nori.nori.step8'), tooltip: t('views.nori.nori.stepDetails8'), isVisited: false, selBlockWiseNum: [{ id: 1, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 2, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 3, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 4, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 5, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 6, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 7, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 8, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 9, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 10, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }], numOfBlocks: 2, isDone: false, isSelected: false, component: eightComponent },
        { id: 9, key: 'step9', label: t('views.nori.nori.step9'), isVisited: false, isDone: false, isSelected: false, component: ninthComponent }
      ])

  const [activeStep, setActiveStep] = useState(steps.length ? steps[0] : '')
  const [npc, setNpc] = useState({})
  const { refetch: refetches } = useQuery('nori-combinations', () => noriCombinations(steps), {
    enabled: false,
    select: (data) => {
      return data?.data
    },
    onSuccess: (data) => {
      data.rcb = data.rcb.toFixed(6)
      setNpc(Object.assign(npc, data))
    },
    onError: () => {
      navigate('/error', { state: { errorMsg: t('views.nori.nori.error') } })
    }
  })
  const handleNext = () => {
    const result = [...steps]
    let index = [...steps, ...[]].sort((a, b) => a.id - b.id).find((x) => x.id > activeStep.id && x.isSelected === true)
    if (index === undefined) {
      refetches()
      index = result[8]
    } else {
      setSteps(prevStep => prevStep.map(x => {
        if (x.id === activeStep.id) {
          x.isDone = true
          x.isVisited = true
        }
        return x
      }))
    }
    if (activeStep.id === 9) navigate('/', { state: { ticketState: tickets, noOfComb: partNoriComp.noOfComb, secSection: true, currentPoolData: state?.currentPoolData || homeData.currentPoolData, ncbTickets: npc?.ncb, stepsTickets: JSON.stringify(steps) } })
    setSteps(prevStep => prevStep.map(x => {
      if (x.id === activeStep.id) {
        x.isDone = true
        x.isVisited = true
      }
      return x
    }))
    setPrevActiveStep(true)
    setActiveStep(index)
    setLoading({ ...loading, status: true })
    setTimeout(() => {
      setLoading({ ...loading, status: false })
    }, 300)
  }
  const handleBack = () => {
    const index = [...steps, ...[]].sort((a, b) => b.id - a.id).find(x => activeStep.id - 1 > 1 && x.isSelected === false ? x.id === 1 : x.id < activeStep.id && x.isSelected === true)
    if (index === undefined) navigate('/', { state: { ticketState: tickets, noOfComb: partNoriComp.noOfComb, secSection: true, currentPoolData: state?.currentPoolData || homeData.currentPoolData, ncbTickets: npc?.ncb, stepsTickets: JSON.stringify(steps) } })
    setSteps(prevStep => prevStep.map(x => {
      if (x.id === activeStep.id) {
        x.isDone = true
        x.isVisited = true
      }
      return x
    }))
    setPrevActiveStep(true)
    setActiveStep(index)
    setLoading({ ...loading, status: true })
    setTimeout(() => {
      setLoading({ ...loading, status: false })
    }, 300)
  }
  const jumpToStep = (stepNo) => {
    const result = [...steps]
    const findEle = result.findIndex((a) => a.id === stepNo)
    setSteps(prevStep => prevStep.map(x => {
      if (x.id !== stepNo && x.id === activeStep.id) {
        x.isDone = true
        x.isVisited = true
      }
      return x
    }))
    setPrevActiveStep(true)
    setActiveStep(result[findEle])
    setLoading({ ...loading, status: true })
    setTimeout(() => {
      setLoading({ ...loading, status: false })
    }, 300)
    return <ScrollTop />
  }

  const [selectedTicket, setSelectedTicket] = useState(1)
  const [showTicketModal, setShowTicketModal] = useState(false)
  const showTicketModalToggle = (x) => {
    setSelectedTicket(x)
    return setShowTicketModal(!showTicketModal)
  }
  return (
    <>
      {/** <Modal2 title="Important Note!" content1="Buying tickets is not possible in this alpha test version." validate="OK" onClose={() => setShowBuy(false)} show={showBuy} /> */}
      {showBuy
        ? tickets[0].confirmClick
          ? <BuyModal
            showBuy={showBuy}
            setShowBuy={setShowBuy}

            nbrTicket={tickets.filter((t) => t.totalSelectedNo === 6).length}
            competition={partNoriComp.noriComp}
            ticket={tickets}

            nps={steps}
            ncb={npc?.ncb}
          />
          : null
        : null
      }
      <TicketModal modal={showTicketModal} toggle={showTicketModalToggle} selectedTicket={tickets} setSelectedTicket={setTickets} ticketNo={selectedTicket} setTicketNo={setSelectedTicket} />

      {loading.status ? <Loading addClass={'active'} /> : ''}
      {prevActiveStep ? <ScrollTop /> : ''}
      <Header activeTab={1} tickets={tickets} currentPoolData={state?.currentPoolData || homeData.currentPoolData} ncbTickets={npc?.ncb} stepsTickets={JSON.stringify(steps)} />
      <div className="stepper-sec">
        <Sidebar sideActiveTab={1} tickets={tickets} currentPoolData={state?.currentPoolData || homeData.currentPoolData } ncbTickets={npc?.ncb} stepsTickets={JSON.stringify(steps)} />
        <div className="box">
          <img src={blueballimg} className='blueballimg' />
          <div className="step-component step-header">
            <div className='steps-left-sec left-header-sec'>
              <h1>{t('views.nori.nori.buildANori')}</h1>
              <div className="steps">
                {!partNoriComp.generationComp ? <span onClick={() => jumpToStep(1)}>{t('views.nori.nori.options')}</span> : <span>{t('views.nori.nori.options')}</span>}
                <ul className="nav">
                  {[...steps, ...[]].sort((a, b) => a.id - b.id).map((step, i) => {
                    return (
                      step.id < 9
                        ? <li key={i} className={activeStep.id !== 1 && activeStep.id === step.id && step.isVisited === false ? 'activate' : step.isDone ? 'done' : step.isSelected ? 'selected' : ''}>
                          {step.isSelected && step.id !== 1 && !partNoriComp.generationComp ? <div onClick={() => jumpToStep(step.id)} key={i}><span key={i}><a key={i}>{step.id}</a></span></div> : <div key={i}><span key={i}>{step.id}</span></div>}
                        </li>
                        : ''
                    )
                  }
                  )}
                </ul>
              </div>
            </div>
            <div className='step-right-slider-sec'></div>
          </div>
          <div className="step-component">
            <div className='steps-left-sec '>
              <div>
                {activeStep.component()}
              </div>
              <img src={redballimg} className='redballimg' />
              {!isLoading
                ? <div className="btn-component">
                  {!partNoriComp.generationComp
                    ? <div>
                      <input type="button" value={steps[0].id === activeStep.id ? t('views.nori.nori.menu') : t('views.nori.nori.prev')} onClick={handleBack} />
                    </div>
                    : ''}
                  <div>
                    <input type="button" value={steps[steps.length - 1].id !== activeStep.id ? t('views.nori.nori.next') : t('views.nori.nori.goMenu')} onClick={handleNext} />
                  </div>
                  {partNoriComp.generationComp
                    ? <div>
                      <input className='buyLuncher' type="button" value={t('views.nori.nori.buyTickets')} onClick={() => setShowBuy(true)} />
                    </div>
                    : ''}
                </div>
                : <div className="activeProgressbar"> <img src={loaderimg} />
                </div>
              }
            </div>
            <div className='step-right-slider-sec'>
              {partNoriComp.generationComp
                ? <div className='generationCompleteLight'></div>
                : ''
              }
              <button onClick={goPrev} className='custom-left-btn'>
                <img src={previcon} />
              </button>
              <button onClick={goNext} className='custom-right-btn'>
                <img src={nexticon} />
              </button>
              <Slider slidesToShow={slides} ref={winningnumbersslider} vertical={isVertical} className="right-step-slider">
                {tickets.length && tickets.map(ticket =>
                  ticket.totalSelectedNo === 6

                    ? <div key={ticket.id} onClick={() => { showTicketModalToggle(ticket.id); sessionStorage.setItem('tmpList', JSON.stringify(ticket)) }}>

                      <ul className='hexagone-list orange'>
                        {Array.from(Array(42), (op, i) =>
                          ticket?.selectedNo?.includes(i + 1) === true
                            ? <li key={i + 1} className='active'>{i + 1}</li>
                            : <li key={i + 1}></li>
                        )}
                      </ul>
                      <span className={ticket.id > 999 ? 'ticket-number three' : 'ticket-number'}>{ticket.id}</span>
                    </div>
                    : <div key={ticket.id} onClick={() => { (ticket.id === 1 || tickets[(ticket.id - 2)].totalSelectedNo === 6) ? showTicketModalToggle(ticket.id) : <div></div> }}>
                      <ul className='hexagone-list'>
                        {Array.from(Array(42), (op, i) =>
                          ticket?.selectedNo?.includes(i + 1) === true
                            ? <li key={i + 1} className='active'>{i + 1}</li>
                            : <li key={i + 1}></li>
                        )}
                      </ul>
                      <span className={ticket.id > 999 ? 'ticket-number three' : 'ticket-number'}>{ticket.id}</span>
                    </div>
                )}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <Footer isVisibleBall={false} scoreDate={state?.currentPoolData?.lastWiNs || homeData.lastWiNs} currentPool={state?.currentPoolData?.lastDraws || homeData.lastDraws} graphData={state?.currentPoolData?.lastHundredDraws || homeData.lastHundredDraws} />
      <Modal toggle={limitToggleModal} className='settings-popup' isOpen={limitModal}>
        <ModalBody>
          <div className='common-modal-sec'>
            <button onClick={limitToggleModal} className='common-close-btn'><img src={closeicon} /></button>
            <h3>{t('global.attention')}</h3>
            <p>{t('views.quickPick.additional')}</p>
            <div className='settings-btn-grp'>
              <a onClick={limitToggleModal} className='small-btn common-white-btn'>{t('global.ok')}</a>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}
export default Nori
